module.exports = __webpack_public_path__ + "img/nik-macmillan-280300-unsplash.ec2987e0.jpg";